// 我发起的-编辑 | 待提交物料-编辑
import { useEffect, useReducer } from 'react'
import { Button, message, Form, Skeleton, Space, Divider } from 'antd'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
import {
  EDIT_PRODUCTCHILD,
  GET_PRODUCT_DETAIL,
  POST_EDIT_TO_SUBMIT_PRODUCT,
} from '../../api/MaterialApi'
import { GET_CATEGORY_FRONTEND_HINT_TEXT } from '@/api/categoryQualificationApi'
import { history, useTypedSelector } from '../../redux/store'
import { reportProjectCategoryAdoptions } from '@/tools/projectCategoryAdopt'
import { useDispatch } from 'react-redux'
import { ProductChildParams } from '../../api/Params'
import { setformStateInitAction } from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import useHook from './hook'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import MaterialType from '../../modules/goodsdetailmodules/materialType'
import AssociationItems from '../../modules/goodsdetailmodules/associationItems'
import { isResponseCodeSuccess } from '../../tools/util'
import { materialTypeEnum } from '../../global/enum/product'
import ExternalLink, {
  ExternalLinkType,
  toExternalLinkPayload,
} from '@/modules/goodsdetailmodules/externallink'

// 路由参数
interface RouteParam {
  productId: string
  BtnState?: MaterialDetailType[] // 模块状态
}

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  CHANGE_LOADING: 'CHANGE_LOADING',
  setDetailDataActopm: 'setDetailDataActopm',
}
interface State {
  // 当前参数
  currentparam: RouteParam
  isloading: boolean
  detailData: any
}

export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
const defaultState: State = {
  currentparam: {
    productId: '',
  },
  isloading: false,
  detailData: {},
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case ACTION_TYPE.CHANGE_LOADING:
      arr.isloading = action.value
      return arr
    case 'setDetailDataActopm':
      arr.detailData = action.value
      return arr
    default:
      return { ...state }
  }
}

// 设置当前页面参数
const setCurrentParamAction = (params: RouteParam) => ({
  type: ACTION_TYPE.SET_CURRENT_PARAM,
  value: params,
})
const setChangeLoading = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_LOADING,
  value: params,
})
// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

const setDetailDataActopm = (params: any) => ({
  type: 'setDetailDataActopm',
  value: params,
})

const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    platform_form,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    onChangeBrandSale,
    onClickClose,
    onChangeLoading,
    getformatFormFields,
    reloaddata,
    tempCode,
    setTempCodeFun,
    onChangeDelivery,
    setMaterialType,
    formatFormFields,
    changeItemList,
    onFieldsChange,
    externalLinkList,
    setExternalLinkList,
    setQualityDataList,
    setAiAuditErrorReasonForField,
    buildFieldErrorReasonMap,
    setDetailAuditType,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const dispatchRedux = useDispatch()
  const {
    pictures,
    qualDocFileList,
    requiredAttachTypes,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    loadingPage,
    hasDelivery,
    materialType,
    itemsList,
    unitDisabled,
    qualityDataList,
    aiAuditErrorReasonForField,
  } = usehookstate
  const { isloading, currentparam } = pagesstate
  const { BtnState } = currentparam
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()
  const { state: routeState } = location

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !routeState) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
    } else if (routeState) {
      dispatch(setCurrentParamAction(routeState))
      dispatchRedux(setformStateInitAction())
      getProductInfo(routeState.productId)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'detailGoods'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 编辑获取数据
  const getProductInfo = async (productId: string) => {
    onChangeLoading(true)
    const res = await GET_PRODUCT_DETAIL({
      productId,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 资质场景：依据详情返参 auditType（ADD/MODIFY）推算
      setDetailAuditType(resData.auditType)
      // 初始进入详情：通过类目 ID 调接口获取当前四级类目的前台提示文案
      const hintRes = await GET_CATEGORY_FRONTEND_HINT_TEXT({
        categoryId: resData.fourthCateMdmId,
      })
      const frontendHintText = isResponseCodeSuccess(hintRes.code)
        ? hintRes.data
        : ''
      await onChangeCate(
        resData.fourthCateMdmId,
        resData.srmProductType,
        resData.code,
        frontendHintText,
      )
      const formatData = formatFormFields(resData)
      form.setFieldsValue(formatData)
      setTempCodeFun(resData.tempCode)
      const newExternalLinks = resData.externalLinks.map((item: any) => {
        return {
          ...item,
          externalFile: item.externalFile ? JSON.parse(item.externalFile) : [],
        }
      })
      setDetailDataActopm(resData)
      setExternalLinkList(newExternalLinks)
      const fieldErrorReasonMap = buildFieldErrorReasonMap(
        resData.reviewConclusion,
      )
      setAiAuditErrorReasonForField(fieldErrorReasonMap)
    }
    onChangeLoading(false)
  }
  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'detailGoods'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 提交新增物料 暂存物料提交 数据
  async function onSubmmit(operateType: string) {
    try {
      // 格式化表单数据
      const values = await getformatFormFields()
      if (
        !itemsList.length &&
        materialTypeEnum.getLabelByValue(values.productType) ===
          '电商供应商物料'
      ) {
        message.error('电商供应商物料至少添加一个关联项目')
        return
      }
      const params: any = {
        ...values,
        saveType: operateType, // 必须 操作类型；1、提交 2、暂存
        externalLinks: toExternalLinkPayload(externalLinkList),
      }
      // 本页不展示运营提报字段，拼出来是空数组，传过去会把已保存的值覆盖掉
      delete params.reportFieldValues
      commit(params)
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }

  // 提交数据 立即提交 暂存
  async function commit(params: ProductChildParams) {
    dispatch(setChangeLoading(true))
    const msg = '提交中'
    message.loading(msg, 0)
    const resData = BtnState?.includes('Edit')
      ? await EDIT_PRODUCTCHILD(params)
      : await POST_EDIT_TO_SUBMIT_PRODUCT(params)
    dispatch(setChangeLoading(false))
    if (resData.code === 0) {
      message.success('操作成功')
      reportProjectCategoryAdoptions()
      onClickClose(history.location.pathname + 'detailGoods')
    } else {
      message.destroy()
    }
  }

  // 按钮类型
  const ButtonComponents = () => {
    let EditBtn = null
    const EditChild = null
    const DisableBtn = null
    const UndisableBtn = null
    const CopyBtn = null
    EditBtn = (
      <Button
        type="link"
        size="small"
        loading={isloading}
        onClick={() => onSubmmit('1')}
      >
        {BtnState?.includes('Edit') ? '提交' : '保存'}
      </Button>
    )
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            {EditBtn}
            {EditChild}
            {DisableBtn}
            {UndisableBtn}
            {CopyBtn}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }
  const diaableMaterialType = () => {
    // 驳回/撤回状态禁止编辑
    if (currentparam.BtnState?.includes('AssessReject')) {
      return true
    }
    return false
  }
  return (
    <Form.Provider>
      <ButtonComponents />
      <div className={Style.container}>
        <div className={Style.box}>
          <Skeleton loading={loadingPage} active>
            <MaterialType
              form={form}
              diaableMaterialType={diaableMaterialType()}
              onFieldsChange={onFieldsChange}
              setMaterialType={setMaterialType}
              type="single"
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>主要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Maininfo
              form={form}
              onFieldsChange={onFieldsChange}
              onChangeCate={onChangeCate}
              onChangeSale={onChangeBrandSale}
              tempCode={tempCode}
              unitDisabled={unitDisabled}
              materialType={materialType}
              aiAuditErrorReasonForField={aiAuditErrorReasonForField}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>次要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Secondaryinfo
              form={form}
              onFieldsChange={onFieldsChange}
              onChangeDelivery={onChangeDelivery}
              hasDelivery={hasDelivery}
            />
          </Skeleton>
        </div>
        {(materialType === '1' || materialType === '2') && (
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>关联项目信息</span>
              {materialTypeEnum.getLabelByValue(
                form.getFieldValue('productType'),
              ) === '电商供应商物料' && (
                <span style={{ color: '#ff4d4f', marginLeft: 10 }}>
                  * 请至少添加一个关联项目
                </span>
              )}
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <AssociationItems
                form={platform_form}
                normalForm={form}
                onFieldsChange={onFieldsChange}
                readOnly={
                  unitDisabled
                  // BtnState?.includes('AssessReject') ||
                  // BtnState?.includes('Edit') && detailData.productMdmId
                }
                isDetailPage={currentparam.BtnState?.includes('AssessReject')}
                itemsList={itemsList}
                changeItemList={changeItemList}
                qualityDataList={qualityDataList}
                setQualityDataListAction={setQualityDataList}
              />
            </Skeleton>
          </div>
        )}
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>拓展属性</span>
            <span className={Style.tips}>
              拓展属性标题为<span className={Style.blueTip}>蓝色</span>
              代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
              <span
                style={{
                  color: '#8C8C8C',
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
              </span>
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Expandattr
              form={form}
              onFieldsChange={onFieldsChange}
              fieldList={fieldList}
              itemsList={itemsList}
              frontendHintText={frontendHintText}
              aiAuditErrorReasonForField={aiAuditErrorReasonForField?.fieldList}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <Divider style={{ margin: '0' }} />
          <AptitudeAttach
            dataSource={qualDocFileList}
            onChange={onChangeAptitude}
            productCode={productCode}
            loading={loadingPage}
            requiredAttachTypes={requiredAttachTypes}
          />
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>外部链接/价格佐证</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <ExternalLink
              form={form}
              externalLinkList={externalLinkList}
              onLinkChange={handleLinkChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>图文信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <div className={Style.picinfobox}>
              {/* <div className={Style.picinfotitle}>
                <span className={Style.text}>图片关系</span>
              </div> */}
              {/* true 显示 匹配、类似 注意必填校验 */}
              <Mainpic required form={form} onFieldsChange={onFieldsChange} />
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  主图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={pictures}
                onChange={onChangePic}
                tempCode={tempCode}
                maxCount={20}
                aiEdit
                aiAuditErrorReasonForField={aiAuditErrorReasonForField?.picList}
              />
              {/* true 显示 可用、不可用 注意必填校验 */}
              <div hidden>
                <Originalpic
                  required={false}
                  form={form}
                  onFieldsChange={onFieldsChange}
                />
              </div>
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  详情图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={detailPic}
                onChange={onChangeDetailPic}
                tempCode={tempCode}
                isDetailPic
                maxCount={100}
                aiEdit
                aiAuditErrorReasonForField={
                  aiAuditErrorReasonForField?.contentUrlList
                }
              />
            </div>
          </Skeleton>
        </div>
      </div>
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 我发起的-编辑
  | 'Edit'
  // 待提交物料-编辑
  | 'ToSubmitEdit'
  // 审核驳回物料
  | 'AssessReject'
// 我发起的-编辑 | 待提交物料-编辑
import { useEffect, useReducer } from 'react'
import { Button, message, Form, Skeleton, Space, Divider } from 'antd'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
import {
  EDIT_PRODUCTCHILD,
  GET_PRODUCT_DETAIL,
  POST_EDIT_TO_SUBMIT_PRODUCT,
} from '../../api/MaterialApi'
import { GET_CATEGORY_FRONTEND_HINT_TEXT } from '@/api/categoryQualificationApi'
import { history, useTypedSelector } from '../../redux/store'
import { reportProjectCategoryAdoptions } from '@/tools/projectCategoryAdopt'
import { useDispatch } from 'react-redux'
import { ProductChildParams } from '../../api/Params'
import { setformStateInitAction } from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import useHook from './hook'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import MaterialType from '../../modules/goodsdetailmodules/materialType'
import AssociationItems from '../../modules/goodsdetailmodules/associationItems'
import { isResponseCodeSuccess } from '../../tools/util'
import { materialTypeEnum } from '../../global/enum/product'
import ExternalLink, {
  ExternalLinkType,
  toExternalLinkPayload,
} from '@/modules/goodsdetailmodules/externallink'

// 路由参数
interface RouteParam {
  productId: string
  BtnState?: MaterialDetailType[] // 模块状态
}

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  CHANGE_LOADING: 'CHANGE_LOADING',
  setDetailDataActopm: 'setDetailDataActopm',
}
interface State {
  // 当前参数
  currentparam: RouteParam
  isloading: boolean
  detailData: any
}

export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
const defaultState: State = {
  currentparam: {
    productId: '',
  },
  isloading: false,
  detailData: {},
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case ACTION_TYPE.CHANGE_LOADING:
      arr.isloading = action.value
      return arr
    case 'setDetailDataActopm':
      arr.detailData = action.value
      return arr
    default:
      return { ...state }
  }
}

// 设置当前页面参数
const setCurrentParamAction = (params: RouteParam) => ({
  type: ACTION_TYPE.SET_CURRENT_PARAM,
  value: params,
})
const setChangeLoading = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_LOADING,
  value: params,
})
// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

const setDetailDataActopm = (params: any) => ({
  type: 'setDetailDataActopm',
  value: params,
})

const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    platform_form,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    onChangeBrandSale,
    onClickClose,
    onChangeLoading,
    getformatFormFields,
    reloaddata,
    tempCode,
    setTempCodeFun,
    onChangeDelivery,
    setMaterialType,
    formatFormFields,
    changeItemList,
    onFieldsChange,
    externalLinkList,
    setExternalLinkList,
    setQualityDataList,
    setAiAuditErrorReasonForField,
    buildFieldErrorReasonMap,
    setDetailAuditType,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const dispatchRedux = useDispatch()
  const {
    pictures,
    qualDocFileList,
    requiredAttachTypes,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    loadingPage,
    hasDelivery,
    materialType,
    itemsList,
    unitDisabled,
    qualityDataList,
    aiAuditErrorReasonForField,
  } = usehookstate
  const { isloading, currentparam } = pagesstate
  const { BtnState } = currentparam
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()
  const { state: routeState } = location

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !routeState) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
    } else if (routeState) {
      dispatch(setCurrentParamAction(routeState))
      dispatchRedux(setformStateInitAction())
      getProductInfo(routeState.productId)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'detailGoods'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 编辑获取数据
  const getProductInfo = async (productId: string) => {
    onChangeLoading(true)
    const res = await GET_PRODUCT_DETAIL({
      productId,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 资质场景：依据详情返参 auditType（ADD/MODIFY）推算
      setDetailAuditType(resData.auditType)
      // 初始进入详情：通过类目 ID 调接口获取当前四级类目的前台提示文案
      const hintRes = await GET_CATEGORY_FRONTEND_HINT_TEXT({
        categoryId: resData.fourthCateMdmId,
      })
      const frontendHintText = isResponseCodeSuccess(hintRes.code)
        ? hintRes.data
        : ''
      await onChangeCate(
        resData.fourthCateMdmId,
        resData.srmProductType,
        resData.code,
        frontendHintText,
      )
      const formatData = formatFormFields(resData)
      form.setFieldsValue(formatData)
      setTempCodeFun(resData.tempCode)
      const newExternalLinks = resData.externalLinks.map((item: any) => {
        return {
          ...item,
          externalFile: item.externalFile ? JSON.parse(item.externalFile) : [],
        }
      })
      setDetailDataActopm(resData)
      setExternalLinkList(newExternalLinks)
      const fieldErrorReasonMap = buildFieldErrorReasonMap(
        resData.reviewConclusion,
      )
      setAiAuditErrorReasonForField(fieldErrorReasonMap)
    }
    onChangeLoading(false)
  }
  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'detailGoods'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 提交新增物料 暂存物料提交 数据
  async function onSubmmit(operateType: string) {
    try {
      // 格式化表单数据
      const values = await getformatFormFields()
      if (
        !itemsList.length &&
        materialTypeEnum.getLabelByValue(values.productType) ===
          '电商供应商物料'
      ) {
        message.error('电商供应商物料至少添加一个关联项目')
        return
      }
      const params: any = {
        ...values,
        saveType: operateType, // 必须 操作类型；1、提交 2、暂存
        externalLinks: toExternalLinkPayload(externalLinkList),
      }
      // 本页不展示运营提报字段，拼出来是空数组，传过去会把已保存的值覆盖掉
      delete params.reportFieldValues
      commit(params)
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }

  // 提交数据 立即提交 暂存
  async function commit(params: ProductChildParams) {
    dispatch(setChangeLoading(true))
    const msg = '提交中'
    message.loading(msg, 0)
    const resData = BtnState?.includes('Edit')
      ? await EDIT_PRODUCTCHILD(params)
      : await POST_EDIT_TO_SUBMIT_PRODUCT(params)
    dispatch(setChangeLoading(false))
    if (resData.code === 0) {
      message.success('操作成功')
      reportProjectCategoryAdoptions()
      onClickClose(history.location.pathname + 'detailGoods')
    } else {
      message.destroy()
    }
  }

  // 按钮类型
  const ButtonComponents = () => {
    let EditBtn = null
    const EditChild = null
    const DisableBtn = null
    const UndisableBtn = null
    const CopyBtn = null
    EditBtn = (
      <Button
        type="link"
        size="small"
        loading={isloading}
        onClick={() => onSubmmit('1')}
      >
        {BtnState?.includes('Edit') ? '提交' : '保存'}
      </Button>
    )
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            {EditBtn}
            {EditChild}
            {DisableBtn}
            {UndisableBtn}
            {CopyBtn}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }
  const diaableMaterialType = () => {
    // 驳回/撤回状态禁止编辑
    if (currentparam.BtnState?.includes('AssessReject')) {
      return true
    }
    return false
  }
  return (
    <Form.Provider>
      <ButtonComponents />
      <div className={Style.container}>
        <div className={Style.box}>
          <Skeleton loading={loadingPage} active>
            <MaterialType
              form={form}
              diaableMaterialType={diaableMaterialType()}
              onFieldsChange={onFieldsChange}
              setMaterialType={setMaterialType}
              type="single"
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>主要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Maininfo
              form={form}
              onFieldsChange={onFieldsChange}
              onChangeCate={onChangeCate}
              onChangeSale={onChangeBrandSale}
              tempCode={tempCode}
              unitDisabled={unitDisabled}
              materialType={materialType}
              aiAuditErrorReasonForField={aiAuditErrorReasonForField}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>次要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Secondaryinfo
              form={form}
              onFieldsChange={onFieldsChange}
              onChangeDelivery={onChangeDelivery}
              hasDelivery={hasDelivery}
            />
          </Skeleton>
        </div>
        {(materialType === '1' || materialType === '2') && (
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>关联项目信息</span>
              {materialTypeEnum.getLabelByValue(
                form.getFieldValue('productType'),
              ) === '电商供应商物料' && (
                <span style={{ color: '#ff4d4f', marginLeft: 10 }}>
                  * 请至少添加一个关联项目
                </span>
              )}
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <AssociationItems
                form={platform_form}
                normalForm={form}
                onFieldsChange={onFieldsChange}
                readOnly={
                  unitDisabled
                  // BtnState?.includes('AssessReject') ||
                  // BtnState?.includes('Edit') && detailData.productMdmId
                }
                isDetailPage={currentparam.BtnState?.includes('AssessReject')}
                itemsList={itemsList}
                changeItemList={changeItemList}
                qualityDataList={qualityDataList}
                setQualityDataListAction={setQualityDataList}
              />
            </Skeleton>
          </div>
        )}
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>拓展属性</span>
            <span className={Style.tips}>
              拓展属性标题为<span className={Style.blueTip}>蓝色</span>
              代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
              <span
                style={{
                  color: '#8C8C8C',
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
              </span>
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Expandattr
              form={form}
              onFieldsChange={onFieldsChange}
              fieldList={fieldList}
              itemsList={itemsList}
              frontendHintText={frontendHintText}
              aiAuditErrorReasonForField={aiAuditErrorReasonForField?.fieldList}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <Divider style={{ margin: '0' }} />
          <AptitudeAttach
            dataSource={qualDocFileList}
            onChange={onChangeAptitude}
            productCode={productCode}
            loading={loadingPage}
            requiredAttachTypes={requiredAttachTypes}
          />
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>外部链接/价格佐证</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <ExternalLink
              form={form}
              externalLinkList={externalLinkList}
              onLinkChange={handleLinkChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>图文信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <div className={Style.picinfobox}>
              {/* <div className={Style.picinfotitle}>
                <span className={Style.text}>图片关系</span>
              </div> */}
              {/* true 显示 匹配、类似 注意必填校验 */}
              <Mainpic required form={form} onFieldsChange={onFieldsChange} />
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  主图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={pictures}
                onChange={onChangePic}
                tempCode={tempCode}
                maxCount={20}
                aiEdit
                aiAuditErrorReasonForField={aiAuditErrorReasonForField?.picList}
              />
              {/* true 显示 可用、不可用 注意必填校验 */}
              <div hidden>
                <Originalpic
                  required={false}
                  form={form}
                  onFieldsChange={onFieldsChange}
                />
              </div>
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  详情图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={detailPic}
                onChange={onChangeDetailPic}
                tempCode={tempCode}
                isDetailPic
                maxCount={100}
                aiEdit
                aiAuditErrorReasonForField={
                  aiAuditErrorReasonForField?.contentUrlList
                }
              />
            </div>
          </Skeleton>
        </div>
      </div>
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 我发起的-编辑
  | 'Edit'
  // 待提交物料-编辑
  | 'ToSubmitEdit'
  // 审核驳回物料
  | 'AssessReject'
